export interface DonorsInterface {
	id?: number;
	partnerDonorsId: number;
	usersId: number;
	partnersId: number;
	userName: string;
	firstName: string;
	lastName: string;
	email: string;
	alternateEmail?: string;
	address1: string;
	address2: string;
	city: string;
	state: string;
	zip: string;
	phone: string;
	smsOptIn: boolean;
	tempAccount: boolean;
	accountType: string;
	totalSponsored: number;
	currentSponsored: number;
	totalPayments: number;
	countPayments: number;
	lastDonationDate: string;
	archived: boolean;
	referralSource?: string;
}

/** Max length of a "How did you hear about us?" answer, matched to the column. */
export const REFERRAL_SOURCE_MAX_LENGTH: number = 100;
